import clsx from "clsx";
import { type ReactNode, useState } from "react";
import type { CurrencyPrimitive } from "@/api/cashier";
import { AmountInput } from "@/components/amount-input/AmountInput";
import style from "./AmountBox.module.css";

export type AmountBoxProps = {
  label?: string;
  subText?: ReactNode;
  placeholder: string;
  value: string;
  currency: CurrencyPrimitive | undefined;
  disabled?: boolean;
  hasError?: boolean;
  testId?: string;
  children?: ReactNode;
  onChange?: (value: string) => void;
  withFormatting?: boolean;
  maxLength?: number;
  locale: string;
};

export const AmountBox = ({
  label,
  subText,
  placeholder,
  value,
  disabled = false,
  currency,
  testId,
  hasError = false,
  children,
  onChange,
  withFormatting = true,
  maxLength,
  locale,
}: AmountBoxProps) => {
  const [isInputFocused, setIsInputFocused] = useState(false);

  return (
    <div
      className={clsx(
        style["amount-wrapper"],
        disabled && style["amount-wrapper-disabled"],
        hasError && style["amount-wrapper-error"],
        isInputFocused && style["amount-wrapper-focused"]
      )}
    >
      <div className={style["amount-top-wrapper"]}>
        <div className={style["amount-top"]}>{label}</div>
        <AmountInput
          value={value}
          onChange={onChange}
          disabled={disabled}
          currency={currency}
          placeholder={placeholder}
          testId={`${testId}-input`}
          onFocus={() => setIsInputFocused(true)}
          onBlur={() => setIsInputFocused(false)}
          withFormatting={withFormatting}
          maxLength={maxLength}
          locale={locale}
        />
        {subText && (
          <div
            data-testid={`${testId}-amount-bottom`}
            className={style["amount-bottom"]}
          >
            {subText}
          </div>
        )}
      </div>
      <div className={style["amount-children-container"]}>{children}</div>
    </div>
  );
};
